import { render } from "./client_create_modal.vue?vue&type=template&id=460871c6"
import script from "./client_create_modal.vue?vue&type=script&lang=js"
export * from "./client_create_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__